// Core validation offset - requests must be at least this many days in the future to be accepted
const MIN_LEAD_DAYS_FOR_VALIDATION = 0; // Requests must be today or later (no past dates)

// Recommended lead time - requests within this date range from today will be warned.
const MIN_LEAD_DAYS_FOR_WARNING = 10; // Recommend at least 10 days lead time.

export default {
    MIN_LEAD_DAYS_FOR_VALIDATION,
    MIN_LEAD_DAYS_FOR_WARNING,
};
